<template>
  <div id="news">
    <div class="header-img">
      <el-image
        class="asd"
        fit="cover"
        :src="srcUrl"
      ></el-image>
      <el-card class="title" :body-style="{ padding: '0px' }">新闻动态</el-card>
    </div>
    <div class="container">
      <el-card v-for="news in newsList" :key="news.id">
        <div class="card">
          <div class="newImg">
            <el-image fit="cover" :src="news.imgUrl"></el-image>
          </div>
          <div class="newCont">
            <div class="header">
              <div class="title">{{ news.title }}</div>
              <div class="time">{{ news.createTime }}</div>
            </div>
            <div class="desc">{{ news.summary }}</div>
            <div class="btn">
              <el-button
                size="mini"
                @click="goDetails(news.id)"
                type="info"
                plain
              >
                查看详情
                <i class="el-icon-d-arrow-right el-icon--right"></i>
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
      <div class="pager">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getNews } from "../../api/news";
const head = require("../../assets/aaaa.jpg");
export default {
  created() {
    this.find();
  },
  data() {
    return {
      newsList: [],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      srcUrl: head,
    };
  },
  methods: {
    find() {
      getNews().then((res) => {
        if (res.status == 200) {
           this.newsList = res.data.records;
            this.page.total = res.data.total;
        }
      });

    },
    goDetails(id) {
      this.$router.push({ path: "/details", query: { id: id } });
    },
  },
};
</script>

<style lang="less">
#news {
  background-color: #EEEEEE;
  .header-img {
    position: relative;
    .asd {
      height: 300px;
      width: 100%;
    }
    .title {
      position: relative;
      top: -40px;
      line-height: 70px;
      padding-left: 20px;
      font-size: 28px;
      height: 70px;
      margin: 0 auto;
      width: 1100px;
      background-color: #f8f8f8;
    }
  }
  .container {
    min-height: 400px;
    width: 1300px;
    margin: 0 auto;
    padding-bottom: 20px;
    .el-card {
      margin-bottom: 20px;
    }
    .card {
      display: flex;
      flex-direction: row;

      .newImg {
        width: 200px;
        height: 150px;
        margin-right: 30px;
        .el-image {
          width: 200px;
          height: 150px;
        }
      }
      .newCont {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 100%;
        .header {
          display: flex;
          justify-content: space-between;
          .title {
            font-size: 20px;
            font-weight: 600;
          }
          .time {
            color: #bdbdbd;
          }
        }
        .desc {
          // color: aqua;
          margin: 20px 0;
        }
        .btn {
        }
      }
    }
    .pager {
      display: flex;
      justify-content: center;
      width: 100%;
      margin: 20px auto;
    }
  }
}
</style>